<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">Photos for Experiences</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              @click="uploadFile"
              class="min-button no-mb"
            >
              <i class="flaticon-arrow-up"></i>
              <strong class="d-lg-block d-none ml-1"> Upload</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5 forms">
      <div class="row">
        <div class="col-xl-2 col-lg-3 col-md-12">
          <div class="card">
            <div class="row">
              <div class="col-12 col-lg-12 col-md-8">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-4 col-sm-6">
                    <div class="data-block">
                      <span class="title-block">Name</span
                      ><span class="content-block">{{
                        vehicle.parameters.name
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-4 col-sm-6">
                    <div class="data-block">
                      <span class="title-block">Type</span
                      ><span class="content-block">{{
                        showType(vehicle.parameters.type)
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-4 col-sm-6">
                    <div class="data-block">
                      <span class="title-block">Make</span
                      ><span class="content-block capitalize">{{
                        vehicle.parameters.make_label
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-4 col-sm-6">
                    <div class="data-block">
                      <span class="title-block">Model</span
                      ><span class="content-block">{{
                        vehicle.parameters.model_label
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-4 col-sm-6">
                    <div class="data-block">
                      <span class="title-block">Rate Image</span>
                      <div class="text-center">
                        <img
                          :src="vehicle.parameters.image"
                          class="img-fluid-2 mb-4"
                          alt="imgvehicle"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-10 col-lg-9 col-md-12" v-if="images.length > 0">
          <div class="card p-card">
            <div class="row justify-content-start">
              <div
                class="image-media"
                v-for="(item, index) in images"
                :key="index"
              >
                <div v-if="item.type === 'File'">
                  <div class="image-wrapper">
                    <div class="image-overlay"></div>
                    <img
                      v-lazy="item.fileUrl"
                      :alt="showName(item.filePath)"
                      class="preview-image"
                    />

                    <base-button
                      class="delete-button"
                      @click.stop="
                        deleteImagesByFilePath(item.filePath, item.fileUrl)
                      "
                    >
                      <i class="flaticon-delete"></i>
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-10 col-lg-9 col-md-12" v-else>
          <base-alert type="secondary" class="alert-box">
            <h4><strong>There are no images here!</strong></h4>

            Upload images for the product gallery

            <img
              src="~rhomtrip_assets/src/img/character/waiting.png"
              alt="RhomTrip Timer"
              class="character"
            />
          </base-alert>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { CarsAPI, BytescaleAPI, VehiclesAPI } from "../../../../../core/api";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { goBack, setSigOut } from "../../../../../helpers/commons.helpers";
import {
  BYTESCALE_API_PUBLIC_KEY,
  IMAGE_BASE_URL
} from "../../../../../core/config/env";

const uploader = Uploader({
  apiKey: BYTESCALE_API_PUBLIC_KEY
});

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "uploadImagesVehicles",
  data() {
    return {
      makes: [],
      models: [],
      vehicle: {
        parameters: {
          _id: "",
          type: "",
          make: "",
          model: "",
          category: "",
          name: "",
          type_category: "",
          image: require("rhomtrip_assets/src/img/no-preview-car.jpg"),
          make_label: "",
          model_label: "",
          name: "",
          pictures: []
        }
      },
      vehicleTypes: [
        { label: "Boats", value: "boats" },
        { label: "Coach", value: "coach" },
        { label: "Limousine", value: "limousine" },
        { label: "Minibus", value: "minibus" },
        { label: "MidiCoach", value: "midicoach" },
        { label: "Minivan", value: "minivan" },
        { label: "MPV", value: "mpv" },
        { label: "Pickup", value: "pickup" },
        { label: "Premium Sedans", value: "premium_sedans" },
        { label: "SUVs", value: "suvs" },
        { label: "Sedan", value: "sedan" }
      ],
      images: [],
      slug: null,
      carsOptions: []
    };
  },

  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },

      {
        text: "Vehicles Gallery",
        to: "/tools/vehicles-gallery"
      },
      {
        text: "Upload Photos",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.carsOptions = await this.getCarsOptions();
    this.slug = this.$route.params.id;
    this.setLoad(true);
    await this.getCarBySlug(this.slug);
    this.setLoad(false);
  },
  methods: {
    async getCarBySlug(slug) {
      try {
        let { data } = await CarsAPI.getCarBySlug(slug, this.sesion.token);
        if (data.status) {
          let car = data.data;
          this.vehicle.parameters._id = car._id;
          this.vehicle.parameters.type = car.type;
          this.vehicle.parameters.make = car.make;
          this.vehicle.parameters.model = car.model;
          this.vehicle.parameters.make_label = car.make_label;
          this.vehicle.parameters.model_label = car.model_label;
          this.vehicle.parameters.name = car.label;
          this.vehicle.parameters.image = `${IMAGE_BASE_URL}/vehicles/${car.slug}.png`;
          this.carId = car._id;
          this.images = await this.getFilesByPatch(
            `/vehicles/gallery/${this.vehicle.parameters.type}/${this.vehicle.parameters.make}/${this.vehicle.parameters.model}`,
            false
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error loading the Vehicle, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "There was an error loading the Vehicle, please try again"
        );
      }
    },
    showName(patch) {
      return patch.split("/").pop();
    },
    showSize(size) {
      let bytes = size;
      let result = "";
      if (bytes < 1024) {
        result = `${bytes} Bytes`;
      } else if (bytes < 1024 * 1024) {
        result = `${(bytes / 1024).toFixed(2)} KB`;
      } else if (bytes < 1024 * 1024 * 1024) {
        result = `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
      } else {
        result = `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
      }
      return result;
    },
    crumbs(patch) {
      let crumbs = [];
      let routeSegments = patch.split("/").filter(segment => segment !== "");
      let currentPath = "";
      for (let segment of routeSegments) {
        currentPath += `/${segment}`;
        crumbs.push({ label: segment, to: currentPath });
      }
      return crumbs;
    },
    selectVehicleType(type) {
      this.vehicle.parameters.make = "";
      this.vehicle.parameters.name = "";
      this.vehicle.parameters.model = "";
      this.vehicle.parameters.image = this.vehicle.parameters.image = require("rhomtrip_assets/src/img/no-preview-car.jpg");
      let types = this.carsOptions.filter(element => element.type === type);
      this.makes = this.getMakes(types);
    },
    selectVehicleMake(make) {
      if (make) {
        let name = this.carsOptions.find(element => element.make === make);
        this.vehicle.parameters.name = name.make_label;
        this.make_label = this.vehicle.parameters.name;
        this.vehicle.parameters.make = make;
        this.vehicle.parameters.model = "";
        this.models = this.getModels(make);
      } else {
        this.vehicle.parameters.model = "";
        this.models = [];
      }
    },
    async selectVehicleModel(vehicleModel) {
      let model = this.models.find(element => element.value === vehicleModel);
      if (model) {
        this.model = model;
        this.vehicle.parameters.model = model.value;
        this.vehicle.parameters.name = `${this.make_label} ${model.label}`;
        this.vehicle.parameters.image = `${IMAGE_BASE_URL}/vehicles/${model.ref}.png`;
        this.carId = model.carId;
        this.images = await this.getFilesByPatch(
          `/vehicles/gallery/${this.vehicle.parameters.type}/${this.vehicle.parameters.make}/${this.vehicle.parameters.model}`,
          true
        );
      }
    },
    getMakes(types) {
      return types
        .filter((value, index, self) => {
          return self.map(e => e.make).indexOf(value.make) === index;
        })
        .map(element => {
          return {
            label: element.make_label,
            value: element.make,
            type: element.type
          };
        })
        .sort(this.sortAscending);
    },
    getModels(make) {
      return this.carsOptions
        .filter((element, index, self) => {
          return (
            element.make === make &&
            element.type === this.vehicle.parameters.type
          );
        })
        .map(element => {
          return {
            carId: element._id,
            label: element.model_label,
            value: element.model,
            type: element.type,
            make: element.make,
            ref: element.slug
          };
        })
        .sort(this.sortAscending);
    },
    async getFilesByPatch(folderPath, loader) {
      try {
        this.setLoad(loader);
        let { data } = await BytescaleAPI.getFilesByFilePath(folderPath);
        this.setLoad(false);
        if (data) {
          return data.items;
        } else {
          return [];
        }
      } catch (error) {
        this.setLoad(false);
        return [];
      }
    },
    getPaths(vehicle) {
      return {
        folderPath: `/vehicles/gallery/${vehicle.parameters.type}/${vehicle.parameters.make}/${vehicle.parameters.model}`,
        fileName: `${vehicle.parameters.make}-${vehicle.parameters.type}-${vehicle.parameters.model}`
      };
    },
    goToPreviousPage() {
      goBack(this);
    },
    async showUploader(images = [], folderPath, fileName, vehicle) {
      try {
        let files = await this.uploaderOpen(
          20 - images.length,
          folderPath,
          fileName,
          vehicle
        );
        if (files.length) {
          this.images = await this.getFilesByPatch(folderPath, true);
          await this.updatedCar(
            this.carId,
            this.images.map(item => item.fileUrl),
            "The image has been saved successfully"
          );
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async uploadFile() {
      if (!this.$v.vehicle.$invalid) {
        let { folderPath, fileName } = this.getPaths(this.vehicle);
        if (this.images.length < 20) {
          await this.showUploader(
            this.images,
            folderPath,
            fileName,
            this.vehicle
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "No more than 20 images allowed",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$v.vehicle.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Enter Vehicle info to upload images",
          icon: "flaticon-warning-1"
        });
      }
    },
    async uploaderOpen(maxFileCount, folderPath, fileName, metadata) {
      return await uploader.open({
        maxFileCount: maxFileCount,
        maxFileSizeBytes: 1048576, //1MB
        mimeTypes: ["image/jpeg", "image/png"],
        multi: true,
        styles: {
          colors: {
            active: "#528fff",
            error: "#d23f4d",
            primary: "#4b56a6"
          }
        },
        editor: {
          images: {
            crop: false,
            preview: false
          }
        },
        originalFileName: `${fileName}-{UNIQUE_DIGITS_4}{ORIGINAL_FILE_EXT}`,
        path: {
          folderPath: folderPath,
          folderPathVariablesEnabled: true,
          fileName: `${fileName}-{UNIQUE_DIGITS_4}{ORIGINAL_FILE_EXT}`,
          fileNameVariablesEnabled: true
        },
        metadata: {
          vehicleName: metadata.parameters.name,
          vehicleParams: {
            make: metadata.parameters.make,
            model: metadata.parameters.model,
            type: metadata.parameters.type
          }
        }
      });
    },
    async deleteImagesByFilePath(filePath, fileUrl) {
      let { value } = await Swal.fire({
        title: "Delete Image",
        text: "Are you sure do you want delete this image?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        await this.deleteFileByFilePath(filePath, fileUrl);
      }
    },
    async deleteFileByFilePath(filePath, fileUrl) {
      try {
        let isImageInUse = await this.verifyImageUsage([fileUrl]);
        if (!isImageInUse) {
          let { data } = await BytescaleAPI.deleteFileByFilePath(filePath);
          this.images = await this.getFilesByPatch(
            `/vehicles/gallery/${this.vehicle.parameters.type}/${this.vehicle.parameters.make}/${this.vehicle.parameters.model}`,
            true
          );
          await this.updatedCar(
            this.carId,
            this.images.map(item => item.fileUrl),
            "The image has been deleted successfully"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "The image can not be deleted because it is being used in some experience",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updatedCar(carId, pictures = [], message) {
      let isUpdated = await this.updateCarById(carId, { pictures: pictures });
      if (isUpdated) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: message,
          icon: "flaticon-check-3"
        });
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateCarById(carId, car) {
      try {
        let { data } = await CarsAPI.updateCarById(
          carId,
          car,
          this.sesion.token
        );
        if (data.status) {
          return data.data.updated;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async getCarsOptions() {
      try {
        let { data } = await CarsAPI.getCarsOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    showType(type) {
      let car = this.vehicleTypes.find(element => element.value === type);
      return car ? car.label : "";
    },
    async verifyImageUsage(images = []) {
      try {
        let { data } = await VehiclesAPI.verifyImageUsage(
          images,
          this.sesion.token
        );
        if (data.status) {
          return data.data.isImageInUse;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    isInVehicleGalleryModule(modules = []) {
      if (!(modules.indexOf("vehicles-gallery") > -1)) {
        this.setCarSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setCarSearchCriteria"]),
    ...mapActions([])
  },
  computed: {
    ...mapGetters(["sesion", "sigout"])
  },
  components: {
    WSelect
  },
  validations: {
    vehicle: {
      parameters: {
        type: {
          required
        },
        make: {
          required
        },
        model: {
          required
        }
      }
    }
  },
  filters: {},
  beforeRouteLeave(to, from, next) {
    this.isInVehicleGalleryModule(to.meta.modules);
    next();
  }
};
</script>
